import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { FC } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { NewConvergeButton } from '../../../presentation/components/new-button';
import WarningIcon from '@mui/icons-material/Warning';
import './delete-contact-modal.scss';

interface ClaimEntityDetailContactModalProps {
  open: boolean;
  onClose: () => void;
  submissionUuid: string;
  title: string;
  mainMessage: string;
  isdeleteable: boolean;
  cancelLabel: string;
  handelDelete?: () => Promise<void>;
}

export const ClaimEntityDetailContactModal: FC<
  ClaimEntityDetailContactModalProps
> = ({
  open,
  onClose,
  title,
  submissionUuid,
  mainMessage,
  isdeleteable,
  cancelLabel,
  handelDelete,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth={true}
      PaperProps={{
        sx: {
          width: '650px',
          height: '250px',
          maxWidth: 'none',
          maxHeight: 'none',
          margin: 'auto',
        },
      }}
      className="delete-modal-contact"
    >
      <DialogTitle sx={{ padding: 4, paddingBottom: 5, marginBottom: 6 }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          paddingTop="10px"
          paddingRight="15px"
        >
          <Box className="main-title-contact-modal" sx={{ marginTop: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <WarningIcon sx={{ marginRight: '5px' }} /> {title}
            </Box>
          </Box>
          <IconButton
            edge="end"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack>
          <Box>
            <Typography className="modal-message">{mainMessage}</Typography>
          </Box>
        </Stack>

        <Stack className="button-container-contact-modal">
          <Box className="close-btn-Container">
            <NewConvergeButton
              label={cancelLabel}
              variant={isdeleteable ? 'outlined' : 'contained'}
              onClick={onClose}
              data-testid="cancel-delete-vendor-btn"
            />
          </Box>
          {isdeleteable && (
            <Box>
              <NewConvergeButton
                label="DELETE VENDOR"
                onClick={async () => {
                  if (handelDelete) {
                    await handelDelete();
                    onClose();
                  }
                }}
                data-testid="delete-vendor-btn"
              />
            </Box>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
